import { FC } from 'react';
import FieldFormulaTooltip from '@molecules/DebugPanel/FieldFormulaTooltip/FieldFormulaTooltip';
import { ITableColumn, TableColumn } from '@models/Forms/IForms';

/**
 * Жучок правил колонки в шапке (DebugPanel, флаг «Показывать формулы полей»):
 * формулы readonly/required/visibility/min/max/pattern/maxLength/workCalendar и
 * их оверрайды. Значение у колонки не редактируется — оно принадлежит строке,
 * а не колонке, поэтому жучок здесь только про правила.
 *
 * Отдельный модуль, а не сосед по tableButtons: исторически тот тянул
 * TableForm → FormBuilder → EditTable, то есть был замкнут в цикл импортов, и
 * биндинг жучка успевал остаться неинициализированным («FieldFormulaTooltip is
 * not defined» в рантайме). Форма строки уехала в EditTable, но раскладывать
 * жучок обратно по кнопкам смысла нет — он не кнопка.
 */
const ColumnFormulaBug: FC<{ column: TableColumn; viewMode: boolean }> = ({ column, viewMode }) => {
    const col = column as ITableColumn;
    return (
        <FieldFormulaTooltip
            required={'required' in column ? col.required : undefined}
            visibilityRules={'visibilityRules' in column ? col.visibilityRules : undefined}
            readonly={'readonly' in column ? col.readonly : undefined}
            min={'min' in column ? col.min : undefined}
            max={'max' in column ? col.max : undefined}
            pattern={'pattern' in column ? col.pattern : undefined}
            maxLength={'maxLength' in column ? col.maxLength : undefined}
            workCalendarRules={'workCalendarRules' in column ? col.workCalendarRules : undefined}
            fieldKey={column.key}
            isViewMode={viewMode}
            enableOverrides
        />
    );
};

export default ColumnFormulaBug;
